export const transfiguredGems: string[] = [
];
